import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
// token 失效码
const validTokenCode = [10032, 10033, 10034, 10039, 10040, 10041, 10020, 10043, 20021, 20020]

const request = axios.create({
    headers: { 'content-type': 'application/json', source: 16 },
    timeout: 60000
})

request.interceptors.request.use(function (config) {
    config.headers.source = 16
    let token = store.getters['auth/getToken']
    // 开发环境走代理
    if (token) {
        config.headers.token = token
    }
    return config
})

request.interceptors.response.use(function (res) {
    const isSvipReq = res.config.url.startsWith('/hcp/teacherSpace/course/svipLessonPage')
    if (res.data.status === 0) {
        return res.data.content
    } else if (!res.data.status) {
        return res
    } else if (validTokenCode.includes(res.data.status)) { /** 登陆失效 */
        store.dispatch('auth/authInvalid')
        Message.error('登录信息无效')
        return Promise.reject(new Error(res.data.status))
    } else if(res.data.status === 19999){
        const err = new Error(res.data.message)
        return Promise.reject(err)
    } else if (isSvipReq) {
        return res
    } else {
        Message({
            type: 'error',
            message: res.data.message
        })
        const err = new Error(res.data.message)
        err.response = res
        return Promise.reject(err)
    }
})

function createRequest(type, url, data, options, businessOptions = {}) {
    return request[type](url, data, options)
        .then((res) => {
            if (businessOptions.tips) { Message({ message: '操作成功', type: 'success' }) }
            return res
        })
        .catch((err) => {
            if (businessOptions.tips) {
                Message({
                    message: err,
                    type: 'error'
                })
            }
            throw err
        })
}

export function get(url, options) {
    return createRequest('get', url, options)
}

export function post(url, data, options) {
    return createRequest('post', url, data, options)
}

export function put(url, options) {
    return createRequest('put', url, options)
}

const requestExport = {
    get,
    post,
    put
}

export const requestOptions = businessOptions => {
    return {
        get: (url, options) => get(url, options, businessOptions),
        post: (url, data, options) => post(url, data, options, businessOptions),
        put: (url, options) => put(url, options, businessOptions)
    }
}

export default requestExport


// WEBPACK FOOTER //
// ./src/utils/request.js